/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
// @ts-ignore
import blackKeysConfig from './black_keys.ts';
import merge from 'lodash/merge';
import localConfig from './local';

export default merge(
	blackKeysConfig,
	process.env.DEEZER_PLATFORM === 'local' ? localConfig : {},
);
